import { IconButton } from "@mui/material";
import React, { useState } from "react";
import ModalBox from "../../../../ui/ModalBox";
import AddIcon from "@mui/icons-material/Add";

const ServicesRender = ({ row }) => {
  const [openAddService, setOpenAddService] = useState();

  const handleAddServiceClose = () => {
    setOpenAddService(!openAddService);
  };
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div>
        {row?.servises?.map((service, index) => (
          <div key={index}>{service?.name}</div>
        ))}
      </div>
      {/* <IconButton onClick={() => setOpenAddService(true)}>
        <AddIcon color="action" fontSize="small" />
      </IconButton> */}
      <ModalBox
        open={openAddService}
        handleClose={handleAddServiceClose}
        text="The update operation has been completed successfully.."
        openService={true}
        member={row}
        existRow={row}
      />
    </div>
  );
};

export default ServicesRender;
